/**
 * BranchSelect — فلتر الفرع الموحّد لبطاقات ذكاء العملاء.
 *
 * مصدر واحد لعنصر «اختيار فرع واحد / كل الفروع» يُعاد استخدامه حرفيًا في
 * بطاقة «معدل تسجيل العملاء الجدد» وبطاقة «معدل تكرار العملاء» — لا نسخة
 * ثانية. الخيارات تأتي من نفس مصدر البيانات (customer_first_seen.branches).
 */
import React from "react";
import { InfoTip } from "../components/InfoTip";

const TEAL = "#065F46";
const TEAL_SOFT = "#0F766E";
const BORDER = "1px solid rgba(6,95,70,0.20)";

const _lbl = { fontSize: 10, color: TEAL_SOFT, fontWeight: 700 };
const _input = {
  fontSize: 13, padding: "6px 10px", borderRadius: 10,
  border: BORDER, background: "#fff", color: TEAL, fontWeight: 600,
};

export const BranchSelect = ({
  value,
  onChange,
  branches = [],
  testId = "branch-filter",
  label = "الفرع (اختياري)",
  tooltip = "",
}) => (
  <label style={{ display: "grid", gap: 4 }}>
    <span style={_lbl}>
      {label}
      {tooltip ? (
        <span
          data-testid={`${testId}-tooltip`}
 
          style={{ marginInlineStart: 4, cursor: "help", color: TEAL_SOFT }}
        ><InfoTip text={tooltip} />ⓘ</span>
      ) : null}
    </span>
    <select
      data-testid={testId}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={_input}
    >
      <option value="">كل الفروع</option>
      {branches.map((b) => (
        <option key={b.id} value={b.id}>{b.name}</option>
      ))}
    </select>
  </label>
);

export default BranchSelect;
